import { Fragment, useEffect, useState } from "react";

import HexModal from "../../../components/HexModal";
import HexLoader from "../../../components/HexLoader";

import { getProduct } from "../api-handler";

import ProductDetails from "./ProductDetails";

import {
  fetchCart,
  setCartInformation,
} from "../../../redux/reducers/order/order-action";
import { useDispatch } from "react-redux";
import useUser from "../../../features/profile/useUser";
import ProductUpdatedModal from "../../Order/ShoppingCart/Components/ProductUpdatedModal";

import "./style.css";
import { hasExistingCart } from "../../Order/ShoppingCart/CartDetailsView/cart-details-utils";
import { updateStorageOnClearCart } from "./ProductDetails/product-cart-detail-utils";

const ProductDetailModal = ({ productId, material, onClose }) => {
  const [product, setProduct] = useState(false);
  const [loading, setLoading] = useState(true);

  const [messageModal, setMessageModal] = useState(false);

  const dispatch = useDispatch();
  const { isAuthenticated: activeUser } = useUser();

  useEffect(() => {
    const promises = [
      getProduct(productId),
      ...(activeUser ? [fetchCart()] : []),
    ];

    Promise.all(promises)
      .then((response) => {
        const [productDetails, cartDetails] = response;
        setProduct(productDetails.data);

        if (cartDetails) {
          const { carts } = cartDetails.data;
          const isInvalid = Boolean(
            carts.length && !carts[0].cartProducts.length
          );

          if (isInvalid) {
            setLoading(false);
            setMessageModal(isInvalid);
            dispatch(setCartInformation({}));
          } else if (hasExistingCart() && !carts.length > 0) {
            updateStorageOnClearCart();
            setLoading(false);
          } else {
            dispatch(setCartInformation(carts.length ? carts[0] : {}));
            setLoading(false);
          }
        }

        setLoading(false);
      })
      .catch(console.error);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HexModal open={true} closable={true} onClose={onClose}>
      {loading ? (
        <HexLoader />
      ) : (
        <Fragment>
          {messageModal && <ProductUpdatedModal />}
          <ProductDetails product={product} material={material} />
        </Fragment>
      )}
    </HexModal>
  );
};

export default ProductDetailModal;
